// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeDetails_root__2qvbV","text":"EmployeeDetails_text__2CNGR","details":"EmployeeDetails_details__1sUI6","buoy":"EmployeeDetails_buoy__3rQAd"};